module.exports = __webpack_public_path__ + "static/media/option-flexible.8bfe603b.jpg";